interface TitlebarProps {
  title: string;
  icon?: string;
  onClose?: () => void;
  showControls?: boolean;
}

export default function Titlebar({
  title,
  icon,
  onClose,
  showControls = true,
}: TitlebarProps) {
  return (
    <div className="win-titlebar">
      <span className="win-title">
        {icon && <span>{icon} </span>}
        {title}
      </span>

      {showControls && (
        <div className="win-controls">
          <button className="win-btn" aria-label="Minimize">
            _
          </button>
          <button className="win-btn" aria-label="Maximize">
            ☐
          </button>
          <button
            className="win-btn"
            aria-label="Close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
}
